import styled from "styled-components";

import Text from "../../components/Text";
import profileImg from "../../assets/images/profile.jpg";
import coachVideoImage from "../../assets/images/coachVideo.jpg";
import rateStar from "../../assets/images/ratestar.svg";
import playIcon from "../../assets/images/play-icon.png";
import Divider from "../../components/Divider";

const Bio = () => {
  return (
    <div className="bio">
      <div className="bio-wrapper text-[13px] px-4">
        <div className=" xs:flex-col flex md:flex-row justify-between">
          <div className="about md:w-7/12">
            <div className="info">
              <div className="about pb-0 flex xs:flex-col sm:flex-row">
                <div className="img rounded-md overflow-hidden xs:h-48 xs:w-48 p-2 sm:w-1/3 sm:h-full max-w-[220px]">
                  <img
                    src={profileImg}
                    alt=""
                    className="rounded-md w-full h-auto object-cover"
                  />
                </div>
                <div className="bio-text p-2 sm:w-2/3 text-[#8b8b8b]">
                  <div className="name">
                    <Text
                      text="Ebru Bekiroğlu"
                      component={"h1"}
                      classes="text-[23px] text-black font-semibold"
                    />
                  </div>
                  <div className="from">
                    <Text
                      text={"Istanbul, Turkey"}
                      classes="text-sm"
                      component={"p"}
                    />
                  </div>
                  <div className="brief-text mt-2 mb-4">
                    <Text>
                      I am passionate about providing personalized and
                      evidence-based nutrition advice to help you achieve your
                      specific goals and meet your specific needs in a
                      sustainable way!
                    </Text>
                  </div>
                  <div className="languages text-[11px] my-4 text-black">
                    <ul className="flex flex-row">
                      <li className="mr-3">
                        <Text
                          text={"English"}
                          classes="bg-[#ffd2c9] rounded px-[6px] py-1"
                        />
                      </li>
                      <li className="mr-3">
                        <Text
                          text={"Turkish"}
                          classes="bg-[#ffd2c9] rounded px-[6px] py-1"
                        />
                      </li>
                    </ul>
                  </div>
                  <Divider />
                  <div className="review flex justify-between my-4">
                    <div className="clients-number w-1/2">
                      <Text>155 Clients</Text>
                    </div>
                    <div className="rate w-1/2 flex justify-end">
                      <div className="stars flex h-4 w-full justify-end">
                        <img src={rateStar} alt="" className="" />
                        <img src={rateStar} alt="" />
                        <img src={rateStar} alt="" />
                        <img src={rateStar} alt="" />
                        <img src={rateStar} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tags">
              <ul className="list text-[11px] font-semibold flex flex-wrap my-2">
                <li className="mx-1 mb-2">
                  <a
                    href=""
                    className="bg-secondary-600 border text-black rounded-full py-[10px] px-[18px] inline-block hover:bg-black hover:text-white transition-all duration-300"
                  >
                    Digestive Concerns
                  </a>
                </li>
                <li className="mx-1 mb-2">
                  <a
                    href=""
                    className="bg-secondary-600 border text-black rounded-full py-[10px] px-[18px] inline-block hover:bg-black hover:text-white transition-all duration-300"
                  >
                    Digestive Concerns
                  </a>
                </li>
                <li className="mx-1 mb-2">
                  <a
                    href=""
                    className="bg-secondary-600 border text-black rounded-full py-[10px] px-[18px] inline-block hover:bg-black hover:text-white transition-all duration-300"
                  >
                    Intuitive Eating
                  </a>
                </li>
                <li className="mx-1 mb-2">
                  <a
                    href=""
                    className="bg-secondary-600 border text-black rounded-full py-[10px] px-[18px] inline-block hover:bg-black hover:text-white transition-all duration-300"
                  >
                    Older Adults
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="coach-video md:p-4 rounded-lg overflow-hidden md:w-5/12 h-full shrink-0">
            <CoachVideo
              playIcon={playIcon}
              className={`img overflow-hidden cursor-pointer border rounded-lg relative before:transition-all before:duration-500 before:absolute before:content-[''] before:h-full before:w-full before:bg-gradient-to-b before:from-secondary-900/50 before:to-secondary-900/50 before:hover:opacity-70 after:content-[''] after:block after:bg-no-repeat after:absolute after:top-1/2 after:-translate-y-1/2 after:left-1/2 after:-translate-x-1/2 after:h-10 after:w-[60px] after:bg-contain after:bg-center`}
            >
              <img src={coachVideoImage} alt="" className="" />
            </CoachVideo>
          </div>
        </div>
      </div>
    </div>
  );
};

const CoachVideo = styled.div`
  &::after {
    background-image: url(${(props) => props.playIcon});
  }
`;

export default Bio;
